import React, {Component} from "react";
import { Route, Switch, Router, Redirect} from 'react-router-dom'
import PropTypes from 'prop-types'
import ShareHolderLandingPage from '../views/shareholder/ShareHolderLandingPage'
import Owner from '../owner/index'
import { createBrowserHistory } from 'history'
import {container} from '../assets/material-kit-react'
import {withStyles} from '@material-ui/core'

const history = createBrowserHistory();

class MainViewHolder extends Component {

    render(){
        const { classes } = this.props
        return(
            <div className={classes.main}>
                <Router history={history}>
                    <Switch>
                        <Route  exact path="/" component={ShareHolderLandingPage}/>
                        <Route  exact path="/owner" component={Owner}/>
                        {/* <Route  path="/login" component={SignIn}/> */}
                        {/* <Route  path="/login" component={ShareHolderLandingPage}/> */}
                        
                        <Redirect from = "/shareholder" to="/"/>
                        <Redirect from="/login" to="/"/>
                        {/* <Redirect from="/shareholder" to="/"/> */}
                    </Switch>
                </Router> 
            </div>
        )
        
    }

}

const styles = theme => ({
    main: {
       container,
       overflowX: 'hidden!important'
    },
    container: {
        ...container,
        padding: '40px 0px 0px 0px'
    },

})

MainViewHolder.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(MainViewHolder) 